import { ACTIONS, ActionType } from "actions/home/types";
import produce, { Draft } from "immer";
import { LoadingState } from "types/api";
import { HomePageState } from "./types";

export const initialState = {
    data: null,
    status: LoadingState.idle,
};

const home = produce((state: Draft<HomePageState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_HOME_PAGE_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_HOME_PAGE_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload;
            break;
        }
        case ACTIONS.GET_HOME_PAGE_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialState);

export default home;
